import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from 'src/app/_services/event/event.service';
import {Event} from '../../Model/event';
@Component({
  selector: 'app-get-event-id',
  templateUrl: './get-event-id.component.html',
  styleUrls: ['./get-event-id.component.css']
})
export class GetEventIdComponent implements OnInit {

  hero$: any;
  event: any = new Event;
  constructor(private route: ActivatedRoute, private router: Router, private eventService: EventService, private meta: Meta) { }

  ngOnInit(): void {
    const heroId = this.route.snapshot.paramMap.get('id');
    this.eventService.getById(heroId).subscribe(res => {
      this.event = res[0];
    });
  }

}
